import ChatBot from "react-chatbotify";
import flowConfig from "./config/flowConfig";

import GigaBot_avatar from "../../imgs/sensor.png";
import { t } from "i18next";
import { Context } from "../LocalWrapper";
import { useContext, useEffect, useState } from "react";

const GigaBot = () => {
  const context = useContext(Context);
  const [lang, setLang] = useState(context.currentLang.code);

  useEffect(() => {
    setLang(context.currentLang.code);
    // console.log("context.currentLang.code : ", context.currentLang.code);
  }, [context.currentLang.code]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerHeight < 600) {
        document.body.style.overflow = "hidden"; // Lock scroll
      } else {
        document.body.style.overflow = "auto"; // Allow scroll
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      document.body.style.overflow = "auto"; // Reset on unmount
    };
  }, []);

  const settings = {
    general: {
      primaryColor: "#2c3e50",
      secondaryColor: "var(--dark)",
      fontFamily: "Arial, sans-serif",
      showFooter: true,
      desktopEnabled: true,
      mobileEnabled: true,
      dir: context.dir,
      // autoFocusInput: false,
    },

    chatHistory: {
      storageKey: "gigabot_etit_chatbot",
      // disabled: false,
      // maxEntries: 30,
      // // viewChatHistoryButtonText: "Load Chat History ⟳",
      // // chatHistoryLineBreakText: "----- Previous Chat History -----",
      // autoLoad: true,
    },

    chatButton: {
      icon: GigaBot_avatar,
    },
    tooltip: {
      // mode: "",
      text: t("gigaBot_tooltip"),
    },
    header: {
      title: (
        <div
          style={{
            // cursor: "pointer",
            margin: 0,
            fontSize: 20,
            fontWeight: "bold",
          }}
        >
          Tracky
        </div>
      ),
      showAvatar: true,
    },
    fileAttachment: {
      disabled: true,
    },
    emoji: {
      disabled: true,
    },
    footer: {
      text: (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            columnGap: 3,
          }}
        >
          <span key={0}>Powered By </span>

          <span key={1} style={{ color: "var(--primary)", fontWeight: "bold" }}>
            ETIT
          </span>
        </div>
      ),
      // buttons: [Button.FILE_ATTACHMENT_BUTTON, Button.EMOJI_PICKER_BUTTON]
    },
    userBubble: {
      showAvatar: true,
    },
    botBubble: {
      showAvatar: true,
    },
  };

  const styles = {
    chatButtonStyle: {
      width: "4rem",
      height: "4rem",
      bottom: "5rem",
    },
    chatIconStyle: { width: "4rem", height: "4rem" },
    tooltipStyle: {
      fontSize: "15px",
      minWidth: "100px",
      //   height: "50px",
      zIndex: "1",
      // position: "absolute",
      bottom: "5rem",
      right: "6rem",
    },
    userBubbleStyle: {
      backgroundColor: "var(--primary)",
      textAlign: "start", // Align bot messages to the right
      direction: context.dir, // Ensure the text direction is context.dir
    },
    botBubbleStyle: {
      backgroundColor: "var(--dark)",
      textAlign: "start", // Align bot messages to the right
      direction: context.dir, // Ensure the text direction is context.dir
    },
  };

  // console.log("context.dir: ", context.dir);

  return (
    <ChatBot
      dir={context.dir}
      settings={settings}
      flow={flowConfig(lang)}
      styles={styles}
    />
  );
};

export default GigaBot;
